import { FunctionComponent, useEffect, useMemo, useState } from "react";
import { Link } from "react-router";
import { observer } from "mobx-react-lite";

import { Ripple } from "primereact/ripple";

import { useWhitelabelService } from "../../../../services/ServiceHooks/whitelabelHook";
import { Device } from "../../../../stores";
import { useStore } from "../../../../stores/StoreContext";

import "./CompanyLogo.scss";

const CompanyLogoRaw: FunctionComponent = () => {
  const whitelabelService = useWhitelabelService();

  const { navigationStore, userStore, breakpointStore, whitelabelStore } = useStore();

  const currentLanguageCode = userStore.currentLanguage.code.split("-")[0].toLowerCase();

  const [logoUrl, setLogoUrl] = useState<string | undefined>();
  const [logoLoadFailed, setLogoLoadFailed] = useState(false);

  useEffect(() => {
    let objectUrl: string | undefined;
    let isMounted = true;

    const loadLogo = async () => {
      setLogoLoadFailed(false);
      setLogoUrl(undefined);

      const blob = await whitelabelService.getSettingImage(currentLanguageCode);

      objectUrl = blob.size > 0 ? URL.createObjectURL(blob) : undefined;

      if (isMounted) {
        setLogoUrl(objectUrl);
      }
    };

    void loadLogo();

    return () => {
      isMounted = false;

      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [currentLanguageCode, whitelabelStore.lastLogoUpdateAt]);

  const logoMemo = useMemo(() => {
    if (!logoUrl) {
      return null;
    }

    if (breakpointStore.isSmallerThan(Device.Tablet)) {
      return <img src={logoUrl} alt="Company Logo" className="small-logo" onError={() => setLogoLoadFailed(true)} />;
    }

    return <img src={logoUrl} alt="Company Logo" onError={() => setLogoLoadFailed(true)} />;
  }, [logoUrl, breakpointStore.device]);

  return (
    <Link target="_self" to={navigationStore.landingPage.url ?? "/"}>
      <div className="logo-container p-ripple">
        {logoLoadFailed ? "Company Logo" : logoMemo}

        <Ripple />
      </div>
    </Link>
  );
};

export const CompanyLogo = observer(CompanyLogoRaw);
